import Api from "@/services/Api";

export default {
  createProject(params) {
    return Api().post("create-project", params);
  },

  revisionRequest(params) {
    return Api().post("revision-request", params);
  },

  partialInquiry(params) {
    return Api().post("partial-inquiry", params);
  }
};



// WEBPACK FOOTER //
// ./src/services/CrmService.js